import { useState, useEffect } from 'react';

function useTabTitle(initialTitle) {
  const [tabName, setTabName] = useState(initialTitle);

  useEffect(() => {
    document.title = `${tabName} | ALTEP ROMANIA`;
  }, [tabName]);

  return setTabName;
}

export default useTabTitle;